<template>
  <!-- Error page-->
  <div style="height: 78vh" class="d-flex w-100 justify-content-center align-items-center">
    <div class="p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Không thể truy cập vào hệ thống công nợ</h2>
        <p class="mb-2">Bạn không phải thành viên của hệ thống công nợ</p>

        <b-img style="height: 50vh" fluid :src="imgUrl" alt="Error page" />
        <!-- image -->
      </div>
    </div>
    <!--  <b-sidebar
      @hidden="$store.commit('appConfig/UPDATE_EZCLOUD_SIDEBAR', false)"
      v-model="isShow"
      bg-variant="white"
      right
      backdrop
      shadow
      no-header
      width="40%"
    >
      <div class="has-search">
        <ez-icon size="20" icon="ezAr-icon-search" />
        <input
          v-model="searchVal"
          type="text"
          :placeholder="$t('ar_client_input_app_search_placeholder')"
        />
      </div>
      <div style="height: 90vh; overflow-y: auto; overflow-x: hidden">
        <Collapse :key="index" v-for="(item, index) in listClient" :item="item" :index="index" />
      </div>
    </b-sidebar> -->
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import "devextreme/dist/css/dx.light.css";
import DxAccordion from "devextreme-vue/accordion";
import Collapse from "./components/Collapse.vue";
import { defineComponent } from "@vue/composition-api";

import { BLink, BButton, BImg, BCollapse } from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import rawClient from "./listClient.json";
import axios from "axios";

export default defineComponent({
  components: {
    DxAccordion,
    Collapse,
    VuexyLogo,
    BLink,
    BCollapse,
    BButton,
    BImg,
  },
  data() {
    return {
      rawClient: [],
      selectedItems: [],
      searchVal: "",
      listClient: [],

      downImg: require("@/assets/images/pages/error.svg"),
    };
  },

  computed: {
    isShow() {
      return this.$store.state.appConfig.layout.ezCloudAppSidebar.isShow;
    },
    imgUrl() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.downImg = require("@/assets/images/pages/error-dark.svg");
      return this.downImg;
    },
  },
  watch: {
    searchVal(value) {
      this.listClient.forEach((item) => {
        item.appLinks.forEach((appLink) => {
          if (
            appLink.name.includes(value) ||
            appLink.name.includes(value.toUpperCase()) ||
            value === ""
          ) {
            appLink.hide = false;
          } else {
            appLink.hide = true;
          }
        });
      });
    },
  },
  /* mounted() {
    const temp = {}
    axios.post('/api/AR_RSP01/Process',JSON.stringify(temp),{headers:{
      'Content-Type': 'application/json',
    }}).then(res=>{
      if(res.data.Status === "200"){

        this.rawClient = JSON.parse(res.data.Data.AppEzId)
        this.listClient = this.rawClient.map((item) => {
        return { ...item, appLinks: item.appLinks.map((appLink) => ({ ...appLink, hide: false })) };
      })
      }
    })
   
 
  
  }, */
});
</script>

<style lang="scss" scoped>
.product-cate {
  border-top: 1px solid #eee;
}

.dx-state-focused::v-deep .dx-accordion-item {
  border: 1px solid transparent;
  border-top-color: #ddd;
}
.has-search {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  min-height: 32px;
}
.has-search::v-deep input {
  width: 100%;
  margin-left: 12px;
  outline: none;
  border: none;
  background-color: transparent;
}

::v-deep .item {
  color: #000;

  span {
    font-size: 11px;
  }
}
::v-deep .search-bar {
  padding: 4px 6px;
}
@import "@core/scss/vue/pages/page-misc.scss";
@import "@core/scss/vue/libs/dx-grid.scss";
</style>
